<template>
  <div class="w-full flex flex-col overflow-y-scroll" >

    <a class="flex flex-row py-1 w-full justify-start bg-blue-900" @click='onGoHome'>
      <img class="w-10 h-10 ml-1 mr-0" src='/img/PBC_logo.svg' />

      <h3 class="ml-4 text-white font-bold text-2xl">playboxcade</h3>

    </a>

    <client-only>
      <resize-observer @notify='resized' />
    </client-only>

    <div ref='postArea' class='flex flex-col self-center w-full max-w-3xl mt-4' :key='id'>

        <div class="pbc-post-user-box">
          <user :user='getPost.author' class="flex-none text-white"/>
          <div class="pbc-post-title2">{{getPost.title}}</div>
        </div>

        <pbc-post-play v-if='getPost.type === "post"'
                  :game='getPost.game'
                  :start-pixi='true'
                  :id='getPost.game'
                  :fetch='true'
                  :ignore-global-pause='true'
                  :thumbnail='previewThumbnail'
                  class='flex-none w-full'
                  :style='postStyle'
                  :key='id' />

          <img v-else-if='playing && !$apollo.loading && getPost.type === "image"'
                :src='getImageUrl(getPost.image)'
                class="object-contain"
                style='height:28rem' />

          <!--
        <div class="grow" />
          -->

        <div v-if='!$apollo.loading' class="bg-gray-800 h-12 w-full flex flex-row flex-none justify-center p-2">

          <button @click='onDownload'
                      class="px-1 py-2 text-center rounded pbc-button"
                      >

            <download-circle-outline :size='16' />

            <span class="ml-2">Download</span>

          </button>


          <div class="h-12 rounded-lg p-1 flex flex-row text-white">
            <comment-multiple-outline />
              <span>
              {{(getPost.replies||{}).total}}
            </span>
          </div>

          <apollo-mutation 
            :mutation="voteMutation"
            class="flex"
            :variables="{id}">
            <template v-slot="{mutate,loading,error}">
              <button class="flex flex-row main-bar-button mr-3" @click="doVote(id, 'upvote', mutate)">
                <div v-if='loading' class="spinner">&nbsp;</div>
                <pbc-icon icon="heart-outline" v-else-if='!votedData.type' />
                <pbc-icon icon="heart" v-else />
                <p class="ml-1">{{post.upvotes}}</p>
              </button>
            </template>
          </apollo-mutation>



          <pbc-share ref='share'
                          @success='shareSuccess'
                          @copied='shareCopy'
                          @error='shareError'
                          :url='shareUrl'
                          class='p-0 m-0'
                          :title='getPost.title'
                          :text='getPost.title'>
            <template #clickable='{share,busy}'>
              <div v-if='busy' class="mt-4 ml-4 spinner" />
              <button @click='share' class="p-1 text-center rounded pbc-button">
                <share-variant :size='16' />
                Share
              </button>
            </template>
          </pbc-share>


        </div>

        <div class="bg-gray-800 mt-0 self-center m-2 border border-gray-900" style='z-index:1'>
          <div class="flex justify-center p-3">
            <pbc-button :class="textPostButtonClasses" @click="onEditText" class='ml-1 mr-2'>
              <text-icon :size='24' />
              <span class="ml-2">Comment</span>
            </pbc-button>

            <pbc-button class="post-type-button pbc-primary-color ml-2 mr-1" @click='onRemix'>

              <movie v-if='getPost.type === "image"' :size='24' />
              <span v-if='getPost.type === "image"' class="ml-2">Animate</span>

              <plus-circle-outline v-if='getPost.type === "post"' :size='24' />
              <span v-if='getPost.type === "post"' class="ml-2">Remix</span>
            </pbc-button>

            <pbc-button v-show='false' :class="imagePostButtonClasses" @click='onEditImage'>

              <image-icon :size='24' />
              <span class="ml-2">Image</span>
            </pbc-button>
          </div>
        </div>

        <router-view  v-if='!$apollo.loading'
                      :parent-id='getPost.id' 
                      :op-id='(getPost.parent||{}).id'
                      :type='editType'
                      class='max-w-lg'
                      @done='onPostingDone'
                    />


        <pbc-popup v-if='showDownloadClips'
                  bgcolor='bg-gray-900'
                  @close='showDownloadClips = false'>
          <download-clips :id='getPost.id' />
        </pbc-popup>


        <apollo-posts 
                      id="top-post"
                      class="mt-2 max-w-lg"
                      type='new'
                      :parent='getPost.id'
                      :disable-type-selection='true'
                      :disable-cta='true'
                      :filter-type='true'
                      pbc-posts-class=''
                      @first-load='onFirstLoad'
                      :disable-load-more='true'
                      :static-type='true' />

        <apollo-posts v-if='false'
                      type='hot'
                      id="top-post"
                      class="mt-2 max-w-lg"
                      feed-type='flat'
                      :disable-type-selection='true'
                      :disable-cta='true'
                      pbc-posts-class=''
                      @first-load='onFirstLoad'
                      :disable-load-more='true'
                      :static-type='true' />
          <pbc-cta2 />


    </div>

    <pbc-message ref='message' />


  </div>
</template>
<script>
import PbcCta2 from '@ui/atoms/PbcCta2.vue';
import ClientOnly from 'vue-client-only';
import { mapState } from 'vuex';
const isServer = !process.browser;
import PbcIcon from '@ui/atoms/PbcIcon.vue';
import Text from '@icons/Text.vue';
import Image from '@icons/Image.vue';
import Movie from '@icons/Movie.vue';
import PlusCircleOutline from '@icons/PlusCircleOutline.vue';
import CommentMultipleOutline from '@icons/CommentMultipleOutline.vue';
import ApolloPosts from '@ui/organisms/ApolloPosts.vue';
import { voteMutation, getPostQuery } from '@/gql/Queries.js';
import PbcPopup from '@ui/molecules/PbcPopup.vue';
import DownloadClips from '@ui/organisms/DownloadClips.vue';
import DownloadCircleOutline from '@icons/DownloadCircleOutline.vue';
import ShareVariant from '@icons/ShareVariant.vue';
import User from '@ui/atoms/User.vue';
import Post from '@icons/Post.vue';
//import Restart from '@icons/Restart.vue';
import { debounce } from 'lodash';
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import PbcShare from '@ui/atoms/PbcShare.vue';
import gql from 'graphql-tag';
import PbcPostPlay from '@ui/molecules/PbcPostPlay.vue';

export default {
  inject:['api'],
  components: {
    PbcPostPlay,
    PbcCta2,
    ClientOnly,
    PbcShare,
    ApolloPosts,
    PbcIcon,
    //Restart,
    //Post,
    User,
    PbcMessage,
    ShareVariant,
    DownloadCircleOutline,
    PbcPopup,
    DownloadClips,
    CommentMultipleOutline,
    TextIcon: Text,
    ImageIcon: Image,
    Movie,
    PlusCircleOutline
  },
  metaInfo() {
    const domain = process.env.VUE_APP_DOMAIN_NAME;
    const type = this.metaType || 'article';
    const url = `https://${domain}/post/${this.getPost.id}`;
    const title = this.getPost.title;
    const author = this.getPost.author;
    const clip = this.interestingClip;
    const clipSize = this.clipSize;
    const thumbnail = this.thumbnail;
    const description = `View ${title} by ${author.username}`;
    const metaInfo = {
      title:this.getPost.title,
      meta:[
        { vmid:'n_des', name:'description',content:description},
        { vmid:'des', property:'description',content:description},
        { vmid:'og_des', property:'og:description',content:description},
        { vmid:'og_title', property:'og:title',content:title},
        { vmid:'og_image', property:'og:image',content:thumbnail},
        { vmid:'og_image_alt', property:'og:image:alt',content:title},
        { vmid:'og_url', property:'og:url',content:url},
        { vmid:'og_url', property:'og:url',content:url},
        //{ property:'og:image:width',content:this.description},
        //{ property:'og:image:height',content:this.description},
        { vmid:'og_type', property:'og:type',content:type}
      ]

    }

    if (clipSize.width !== -1 && clipSize.height !== -1) {
      metaInfo.meta.push({ vmid:'og_image_w', property:'og:image:width',content:clipSize.width});
      metaInfo.meta.push({ vmid:'og_image_h', property:'og:image:height',content:clipSize.height});

      //metaInfo.meta.push({ property:'og:video', content: this.api.makeClipUrl(clip.mp4Url)});
      metaInfo.meta.push({ property:'og:video:url', content: this.api.makeClipUrl(clip.mp4Url)});
      metaInfo.meta.push({ property:'og:video:secure_url', content: this.api.makeClipUrl(clip.mp4Url)});
      metaInfo.meta.push({ property:'og:video:width', content: clipSize.width});
      metaInfo.meta.push({ property:'og:video:height', content: clipSize.height});
      metaInfo.meta.push({ property:'og:video:type', content: 'video/mp4'});
    }

    return metaInfo;
  },

  /*
  serverPrefetch() {
    console.log('call prefetchersssssssss');
    return new Promise( (resolve) => {
      console.log('done prefetchersssssssss');
      setTimeout(resolve, 10000);
    });
  },
  */
  apollo: {
    getPost: {
      query: getPostQuery,
      fetchPolicy: isServer ? 'network-only' : 'cache-and-network',
      //fetchPolicy: isServer ? 'network-only' : 'cache-only',
      variables() {
        return {
          id: this.$route.params.id
        }
      },
    }
  },
  data() {

    return {
      getPostQuery,
      playing: true,
      resized:debounce(this._resized, 400),
      showDownloadClips: false,
      gamedata:{},
      voteMutation,
      votedData:{},
      getPost:{
        id:'unknown',
        title:'loading...',
        author:{
          id:'anonymous',
          username:'anonymous'
        },
        clips:[
        ]
      },
      postStyle:{}
    }
  },
  created() {
    console.log('created get post', JSON.stringify(this.getPost,0,2));
  },
  beforeDestroy() {
    this.$store.commit('popupBeingShown', false);
  },
  mounted() {
    this.$store.commit('popupBeingShown', true);
    console.log('mounted get post', JSON.stringify(this.getPost,0,2));
    this.$ana.track({
      eventCategory:'ui',
      eventAction:'viewPost',
      extra:{id:this.id}
    });
  },
  methods:{
    onGoHome() {
      this.$router.push({
        name:'new'
      });
    },
    onPostingDone({post}) {
      console.log('posting done', this.$route.params, post);
      this.$router.push({
        name:'play',
        params:Object.assign({}, this.$route.params, {
          id:post.parent.id
        })
      });
    },
    onEditImage() {
      if (this.$route.name !== 'createImagePost') {
        this.$router.push({
          name:'createImagePost',
          params:{
            type:'image'
          },
          hash:'#editor'
        });
      } else {
        this.$router.push({
          name:'play',
          hash:'#editor'
        });
      }
    },
    onEditText() {
      if (this.$route.name !== 'createTextPost') {
      this.$router.push({
        name:'createTextPost',
        params:Object.assign({}, this.$route.params, {
          type:'text',
        }),
        hash:'#editor'
      });
      } else {
        this.$router.push({
          name:'play',
          params:Object.assign({}, this.$route.params, {
            type:'text',
          }),
          hash:'#editor'
        });
      }
    },
    getImageUrl(url) {
      return this.api.makeImageUrlEditor(url);
    },
    onFirstLoad() {
      if (this.$route.query.type === 'posted') {
        this.$router.replace({query:{}});
        console.log('on first loaded');
        setTimeout( () => {
          //document.querySelector('#top-post').scrollIntoView({
          document.querySelector('#top-buttons').scrollIntoView({
            behavior:'smooth'
          });
        }, 100);
      }
    },
    onRemix() {
      this.$router.push({
        name:'start',
        params:{
          parentId: this.id,
          type: 'post'
        }
      });
    },
    onDownload() {
      this.showDownloadClips = true;
    },
    shareSuccess() {
      console.log('share success');
      this.$refs.message.show({
        title:'Link shared.'
      });

      const id = this.getPost.id
      this.$ana.track({
        eventCategory:'share',
        eventAction:'view-success',
        extra:{
          id
        }
      });
    },
    shareCopy() {
      const id = this.getPost.id
      this.$refs.message.show({
        title:'Link copied.'
      });
      this.$ana.track({
        eventCategory:'share',
        eventAction:'view-success',
        extra:{
          id,
        }
      });
    },
    shareError(message) {
      const id = this.getPost.id
      this.$refs.message.show({
        type:'error',
        title:'Something went wrong.'
      });
      this.$ana.track({
        eventCategory:'share',
        eventAction:'view-copy',
        extra:{
          id,
          message
        }
      });
    },
    restart() {
      this.playing = false;
      setTimeout( () => {
        this.playing = true;
      }, 100);
    },
    async getGameData(id) {
      const data = await this.$apollo.query({
        query:gql(`
        query getGame($id: String!) {
          getGame(id: $id)
        }
        `),
        variables: {
          id
        }
      });
      return JSON.parse(data.data.getGame);

    },
    _resized() {
      if (this.$vhcheck) {
        this.$vhcheck.emit('recompute');
      }
      /*
      this.$refs.message.show({
        title:'afokkenresize'
      });
      */
      /*
      this.$refs.editRenderer.resizeCanvas();
      window.requestAnimationFrame( () => {
        this.$refs.editRenderer.updateAllContainerBounds();
      });
      */
    },
    async doVote(id, type, mutate) {
      if (!this.loggedIn) {
        this.$router.push({
          query:{
            loginPrompt:true
          },
        });
        return;
      }

      const voted = await mutate({variables: {id, type}})
      this.votedData = {
        type
      }
      return voted;
    },
    setSize() {
      const width = this.$refs.postArea.getBoundingClientRect().width;
      console.log('wwwwwwwwwwwww', width);
      const aspect = this.metadata.rows / this.metadata.cols;
      this.postStyle.height = (width * aspect) + 'px';
    }

  },
  watch:{
    getPost() {
      this.setSize();
    },
  },
  computed:{
    previewThumbnail() {
      if (this.interestingClip.thumbnail) {
        return this.api.makeThumbnailUrlUI(this.interestingClip.thumbnail);
      } else {
        return undefined;
      }
    },
    metaType() {
      return this.$route.query.type || 'article';
    },
    video() {
      return this.interestingClip;
    },
    thumbnail() {
      const post = this.getPost;
      const clip = this.interestingClip;
      const screenshot = this.interestingScreenshot;
      if (screenshot.id) {
        return this.api.makeScreenshotUrlUI(post.id, screenshot.id);
      } else if (clip.thumbnail) {
        return this.api.makeThumbnailUrlUI(clip.thumbnail);
      } else {
        return this.api.makeAssetUrl('icons/android-chrome-512x512.png');
      }
    },
    interestingScreenshot() {
      const clip = this.interestingClip;
      if (clip.screenshots.length) {
        const i = Math.min(clip.screenshots.length, 1);
        const screenshot = clip.screenshots[i];
        return screenshot;
      } else {
        return {};
      }
    },
    interestingClip() {
      if (this.getPost.clips.length) {
        return this.getPost.clips[0];
      } else {
        return {screenshots:[]};
      }
    },
    clipSize() {
      if (this.interestingScreenshot) {
        const res = (this.interestingScreenshot.resolution||'-1x-1').split('x').map( (x) => {
          return parseInt(x);
        });
        return {
          width:res[0],
          height:res[1]
        }
      } else {
        return {
          width:-1,
          height:-1
        }
      }
    },
    metadata() {
      return this.post.metadata || {cols:11,rows:16}
    },
    post() {
      return this.getPost||{}
    },
    shareUrl() {
      return `${process.env.VUE_APP_DOMAIN_NAME}/post/${this.getPost.id}`;
    },
    id() {
      return this.getPost.id;
    },
    editType() {
      if (this.$route.name === 'createTextPost') {
        return "text";
      }
      if (this.$route.name === "createImagePost") {
        return "image";
      }
      return "text";
    },
    textPostButtonClasses() {
      const classes = ['post-type-button'];
      if (this.$route.name === 'createTextPost') {
        classes.push('post-type-button-selected');
      }
      return classes;
    },
    imagePostButtonClasses() {
      const classes = ['post-type-button'];
      if (this.$route.name === 'createImagePost') {
        classes.push('post-type-button-selected');
      }
      return classes;
    },
    ...mapState(['loggedIn'])
  }
}
</script>
<style scoped>
.edit-options-box {
  @apply shadow-lg;
    position: sticky;
    top: 2em;
}
.sticky-top {
    position: sticky;
    top: 0;
}
</style>
